import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Smooth-scrolls to anchor (#id) when the route includes a hash.
export default function ScrollToHash() {
  const { hash, pathname } = useLocation();
  useEffect(() => {
    if (!hash) return;
    const id = hash.replace(/^#/, "");
    // Wait a tick for content to render
    const t = setTimeout(() => {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 80);
    return () => clearTimeout(t);
  }, [hash, pathname]);
  return null;
}
